import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { Box, Paragraph, Text, TextInput, Button } from 'grommet';
import Header from '../Components/Header';
import Footer from '../Components/Footer';

class Error extends React.Component {

    render() {

        return (

            <Box>
                {this.props.testo.length > 0 ? <Text className='error'>{this.props.testo}</Text> : <div className='margin-error'></div>}
            </Box>
        );
    }
}

 class InsertEmail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: 'test@mail.com',
            buttonState: this.email !== '' ? false : true,
            msgError: ''
        }
        this.continue = this.continue.bind(this);

    }

    setEmail = (e) => {
        this.setState({
            email: e.target.value,
        }, function () {
            this.disableButton()
        })
    }

    disableButton = () => {
        //var regexEmail = /^([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
        const regexEmail = /^([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})$/;
        var email = regexEmail.test(this.state.email)

        if (email) {
            this.setState({
                buttonState: false,
                msgError: ''
            })
        }
        else if (this.state.email === '') {
            this.setState({
                buttonState: true,
                msgError: ''
                
            })
        }
        else if (!email) {
            this.setState({
                buttonState: true,
                msgError: 'Email non valida'
            })
        }
        
    }

    continue() {
        this.props.history.push({
            pathname:'/OTPCode'
        })
    }


    render() {

        return (
            <Box>
                <Header/>

                <Box direction="column" align='center' className='background-color'>
                    <Box direction='row' >
                        <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Inserisci indirizzo email</h1>
                        <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                    </Box>
                    <Box direction='row'>
                        <Paragraph className='textParagraph'>Per garantire la tua sicurezza abbiamo bisogno della tua email</Paragraph>
                    </Box>


                    <Box direction='column' justify='center'>
                        <Text className='label'>Email</Text>
                        <Box direction='row'>
                            <Box style={{width:'100%'}}>
                                <TextInput id='email' size='medium' className={`inputFormdisp ${this.state.msgError ? 'errorBoxInput' : '' }`} style={{width:'100%'}} value={this.state.email} onChange={this.setEmail} />
                                <Error testo={this.state.msgError} />
                            </Box>                        
                        </Box>
                        <Box>
                            <Paragraph className='textParagraph'>Ti invieremo una email a questo indirizzo per confermarlo</Paragraph>
                        </Box>
                    </Box>


                    <Box justify='center' direction='row' style={{marginTop:'50px'}}>
                        <Button className='btnform' style={{width:'170px', margin:'0 30px 30px 0'}} label='INDIETRO' onClick={this.back} />
                        <Button className={this.state.buttonState ? 'btnform disabled' : 'btnform'} style={{width:'170px'}} label='AVANTI' disabled={this.state.buttonState} onClick={this.continue} />
                    </Box>
                </Box>
                <Footer />
            </Box >
        )
    }
}

export default InsertEmail = withRouter(InsertEmail)